import { createAction } from 'redux-starter-kit';


export const putInspectionReason = createAction('PUT_INSPECTION_REASON');
export const putInspectionReasons = createAction('PUT_INSPECTION_REASONS');
